import SkeletonComponent from '@atoms/SkeletonComponent';
import React from 'react';
import styles from './styles';

const ShimmerBPTile = () => <SkeletonComponent style={styles.shimmerBPTile} />;

export default ShimmerBPTile;
